type IgnoreCodeBlocksPluginProps = {
    enabled: boolean
}

export function ignoreCodeBlocks({ enabled }: IgnoreCodeBlocksPluginProps) {
    if (!enabled) {
        return
    }

    // @ts-expect-error it works as it runs as a plugin from remark
    const data = this.data()

    // https://github.com/zestedesavoir/zmarkdown/issues/416#issuecomment-982812961
    data.micromarkExtensions = data.micromarkExtensions || []
    data.micromarkExtensions.push({
        disable: { null: ['codeFenced', 'codeIndented'] },
    })
}
